(function($) {
  $.fn.wsSmartSticky = function(options) {
    const settings = $.extend({
      headerSelector: 'header.header',
      padding: 20,
      minWidth: 1200,
      paddingTop: 0,
      onlyScrollPadding: false,
    }, options);

    return this.each(function() {
      const $sidebar = $(this);
      const $header = $(settings.headerSelector);

      if (!settings.onlyScrollPadding) {
        $sidebar.css('padding-top', settings.paddingTop);
      }

      const updatePosition = () => {
        const windowWidth = window.innerWidth;
        const scrollTop = $(window).scrollTop();

        if (windowWidth < settings.minWidth) {
          $sidebar.css({ 'position': '', 'top': '', 'padding-top': '' });
          return;
        }

        if (settings.onlyScrollPadding) {
          if (scrollTop > 5) {
            $sidebar.css('padding-top', settings.paddingTop);
          } else {
            $sidebar.css('padding-top', '0');
          }
        }

        const $adminBar = $('#wpadminbar');
        const adminBarHeight = ($adminBar.length && $adminBar.css('position') === 'fixed') ? $adminBar.outerHeight() : 0;
        const isHeaderHidden = $header.hasClass('scrolled-down');
        const headerHeight = $header.outerHeight() || 0;

        const windowHeight = window.innerHeight;
        const sidebarHeight = $sidebar.outerHeight();
        const baseTop = isHeaderHidden ? (adminBarHeight + settings.padding) : (adminBarHeight + headerHeight + settings.padding);

        let finalTop = baseTop;
        if (sidebarHeight + baseTop > windowHeight) {
          finalTop = windowHeight - sidebarHeight - settings.padding;
        }

        $sidebar.css({
          'position': 'sticky',
          'top': finalTop + 'px',
          'transition': 'top 0.3s ease-in-out, padding-top 0.3s ease-in-out',
          'align-self': 'start',
        });
      };

      $(window).on('scroll.wsSticky resize.wsSticky', updatePosition);
      updatePosition();
    });
  };
})(jQuery);
